
export interface Grupo {
    id: string ;
    nome: string | null;
    descricao?: string | null;
}

export const ISgrupo: Grupo = {
    id: "",
    nome: "",
    descricao: "",
}